// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__src__App__root","snackbarRoot":"CentricUI__src__App__snackbarRoot"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 1880
// module chunks = 10